import { createNamespace } from '@chenms-zj/utils/create'
import { computed, defineComponent, onMounted, reactive, ref, watch } from 'vue'

export default defineComponent({
  name: 'cms-virtual-list',
  props: {
    size: {
      type: Number,
      default: 35
    },
    remain: {
      type: Number,
      default: 8
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  setup(props, { slots }) {
    const bem = createNamespace('vl')
    const wraperRef = ref<HTMLElement>()
    const barRef = ref<HTMLElement>()
    // 计算显示的区域
    const state = reactive({
      start: 0,
      end: props.remain
    })

    const offset = ref(0)
    const prev = computed(() => {
      // 当前开始第四条
      return Math.min(state.start, props.remain)
    })

    const next = computed(() => {
      return Math.min(props.remain, props.items.length - state.end)
    })

    // 这里应该多展示上8条和下8条,保证用户在快速滚动的时候不会白屏
    const visibleData = computed(() => {
      // 上下都补点
      return props.items.slice(state.start - prev.value, state.end + next.value)
    })

    const handleScroll = () => {
      // 根据当前滚动的距离来算过去了几个数据
      const scrollTop = wraperRef.value!.scrollTop
      // 划过去了多少个
      state.start = Math.floor(scrollTop / props.size)

      state.end = state.start + props.remain
      // 滚过去了多少个
      offset.value = state.start * props.size - props.size * prev.value
    }

    const initWrap = () => {
      wraperRef.value!.style.height = props.remain * props.size + 'px'
      barRef.value!.style.height = props.items.length * props.size + 'px'
    }

    watch(() => props.items, initWrap)

    onMounted(() => {
      initWrap()
    })
    return () => {
      return (
        <div class={bem.b()} ref={wraperRef} onScroll={handleScroll}>
          {/* 模拟总长度,感觉好像很多条数据 */}
          <div class={bem.e('scroll-bar')} ref={barRef}></div>
          {/* 更新列表从哪显示到哪里,一直只显示8条 */}
          <div
            class={bem.e('scroll-list')}
            style={{ transform: `translate3d(0, ${offset.value}px, 0)` }}
          >
            {visibleData.value.map(node => slots.default!({ node }))}
          </div>
        </div>
      )
    }
  }
})
